
import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap';
import api from '../../../utils/api';

const BseTable = () => {
  const roomId = new URLSearchParams(window.location.search).get("clientId");

  const [aofData, setAofData] = useState(null);

  useEffect(() => {
    fetchAofForm();
  }, []);
  const fetchAofForm = async () => {
    try {
      const response = await api.post(
        `advisor/aofForm`,
        { client_id: roomId }
      );
      setAofData(response?.data);
    } catch (error) {
      console.error("Fetch AOF Error:", error);
    }
  };



  return (
    <div><div className="d-flex justify-content-left  mx-auto w-[720px]">
      <form id="applicant-form" style={{ float: "left", padding: "20px" }}>
        <Table bordered className="table-bordered border-dark border-2 table table-sm" style={{ fontSize: '14px', fontFamily: 'Calibri, sans-serif' }}>
          <tbody>
            <tr>
              <td colSpan={4}>
                <div
                  className="pb-5 d-flex justify-content-center "
                  style={{
                    marginTop: "-11px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src="assets/images/BSestarMF.jpg"
                    width={100}
                    alt="Logo"
                  />
                </div>
              </td>
            </tr>
            <tr>
              <td>
                Broker/Agent Code ARN:{" "}
                <span className="fw-bold">{aofData?.broker_agent}</span>
              </td>
              <td colSpan={2}>SUB-BROKER:</td>
              <td>
                EUIN: <span className="fw-bold">{aofData?.euin}</span>
              </td>
            </tr>
            <tr>
              <td colSpan={4}>
                <span className="fw-bold">Unit Holder Information</span>
              </td>
            </tr>
            <tr>
              <td colSpan={4}>
                <span className="fw-bold">
                  Name of the First Applicant:{" "}
                </span>
                <span >
                  {aofData?.nameOfFirstApplicant}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                <span className="">PAN Number:</span>{" "}
                {aofData?.pannumber}
              </td>
              <td>
                <span className="">KYC:</span> Completed
              </td>
              <td colSpan={2}>
                Date of Birth:{" "}
                <span className="">
                  {new Date(aofData?.dobFirst).toLocaleDateString("en-GB")}
                </span>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                Father's Name:{" "}
                <span className="">{aofData?.fatherName}</span>
              </td>
              <td colSpan={2}>
                Mother's Name:
                <span className="">{aofData?.MotherName}</span>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                Name of Guardian:
                <span className="">{aofData?.nomineeGuardian}</span>
              </td>
              <td colSpan={2}>
                PAN: <span className="">{aofData?.nomineeGuardianPan}</span>
              </td>
            </tr>
            <tr>
              <td colSpan={4}>
                <span className="fw-bold">Contact Address:</span>{" "}
                <span className="">
                  {aofData?.addressParts?.contactAddress1},{" "}
                  {aofData?.addressParts?.contactAddress2},{" "}
                  {aofData?.addressParts?.contactAddress3}
                </span>
              </td>
            </tr>
            <tr>
              <td>
                City: <span className="">{aofData?.city}</span>
              </td>
              <td>
                Pincode: <span className="">{aofData?.pincode}</span>
              </td>
              <td>
                State: <span className="">{aofData?.state}</span>
              </td>
              <td>
                Country: <span className="">{aofData?.country}</span>
              </td>
            </tr>
            <tr>
              <td>Tel. (Off):</td>
              <td>Tel. (Res):</td>
              <td colSpan={2}>
                Email: <span className="">{aofData?.email}</span>
              </td>
            </tr>
            <tr>
              <td>Fax. (Off):</td>
              <td>Fax. (Res):</td>
              <td colSpan={2}>
                Mobile: <span className="">{aofData?.mobile}</span>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>Income Tax Slab/Net Worth:</td>
              <td colSpan={2}>
                Occupation Details:<span className=""></span>
              </td>
            </tr>
            <tr>
              <td colSpan={1}>Place of Birth:</td>
              <td colSpan={3}>Country of Tax Residence:</td>
            </tr>
            <tr>
              <td colSpan={4}>Tax Id No.:</td>
            </tr>
            <tr>
              <td colSpan={2}>
                Politically exposed person/Related to Politically exposed
                person etc.?
              </td>
              <td>Yes</td>
              <td>No</td>
            </tr>
            <tr>
              <td colSpan={2}>Mode of Holding: SI - Single</td>
              <td colSpan={2}>
                Occupation:{" "}
                <span className="">{aofData?.occupation}</span>
              </td>
            </tr>
            {/* Second Applicant */}
            <tr>
              <td colSpan={4}>
                <span className="fw-bold">
                  Name of the Second Applicant:{" "}
                </span>{" "}
                <span className=""></span>
              </td>
            </tr>
            <tr>
              <td>
                PAN Number: <span className=""></span>
              </td>
              <td>
                KYC: <span className="">Completed</span>
              </td>
              <td colSpan={2}>
                Date of Birth: <span className=""></span>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>Income Tax Slab/Net Worth:</td>
              <td colSpan={2}>Occupation Details:</td>
            </tr>
            <tr>
              <td colSpan={1}>Place of Birth:</td>
              <td colSpan={3}>Country of Tax Residence:</td>
            </tr>
            <tr>
              <td colSpan={4}>Tax Id No.:</td>
            </tr>
            <tr>
              <td colSpan={2}>
                Politically exposed person/Related to Politically exposed
                person etc.?
              </td>
              <td>Yes</td>
              <td>No</td>
            </tr>
            {/* Third Applicant */}
            <tr>
              <td colSpan={4}>
                <span className="fw-bold">Name of the Third Applicant: </span>{" "}
                <span className=""></span>
              </td>
            </tr>
            <tr>
              <td>
                PAN Number: <span className=""></span>
              </td>
              <td>
                KYC: <span className="">Completed</span>
              </td>
              <td colSpan={2}>
                Date of Birth: <span className=""></span>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>Income Tax Slab/Net Worth:</td>
              <td colSpan={2}>Occupation Details:</td>
            </tr>
            <tr>
              <td colSpan={1}>Place of Birth:</td>
              <td colSpan={3}>Country of Tax Residence:</td>
            </tr>
            <tr>
              <td colSpan={4}>Tax Id No.:</td>
            </tr>
            <tr>
              <td colSpan={2}>
                Politically exposed person/Related to Politically exposed
                person etc.?
              </td>
              <td>Yes</td>
              <td>No</td>
            </tr>
            <tr>
              <td colSpan={4}>
                <span className="fw-bold">
                  Other Details of Sole/1st Applicant:{" "}
                </span>{" "}
                <span className=""></span>
              </td>
            </tr>
            <tr>
              <td colSpan={4}>
                <span className="fw-bold">
                  Overseas Address
                </span>
                <br />
                (in case of NRI Investor):
                <br />
                <span className="">{aofData?.nri_address}</span>
              </td>
            </tr>
            <tr>
              <td>
                City: <span className="">{aofData?.nri_city}</span>
              </td>
              <td>
                Pincode: <span className="">{aofData?.nri_pincode}</span>
              </td>
              <td>
                State: <span className=""></span>
              </td>
              <td>
                Country: <span className="">{aofData?.nri_country}</span>
              </td>
            </tr>



            <tr>
              <td colSpan={4}>
                <span className="fw-bold">Bank Mandate Details</span>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                Name of Bank: <span className="">{aofData?.bank_name}</span>
              </td>
              <td colSpan={2}>
                Branch: <span className="">{aofData?.bank_branch}</span>
              </td>
            </tr>
            <tr>
              <td>
                A/C No.: <span className="">{aofData?.bank_account_number}</span>
              </td>
              <td>
                A/C Type: <span className="">{aofData?.bank_account_type}</span>
              </td>
              <td colSpan={2}>
                IFSC Code: <span className="">{aofData?.bank_ifsc}</span>
              </td>
            </tr>
            <tr>
              <td colSpan={4}>
                <span className="fw-bold">Bank Address:</span><br /> <span className="">{aofData?.bank_address}</span>
              </td>
            </tr>
            <tr>
              <td>
                City: <span className="">{aofData?.bank_city}</span>
              </td>
              <td>
                Pincode: <span className="">{aofData?.bank_pincode}</span>
              </td>
              <td>
                State: <span className="">{aofData?.bank_state}</span>
              </td>
              <td>
                Country: <span className="">{aofData?.bank_country}</span>
              </td>
            </tr>

            <tr>
              <td colSpan={4}>
                <span className="fw-bold">Nomination Details</span>
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                Nominee Name: <span className="">{aofData?.nominee_name || '-'}</span>
              </td>
              <td colSpan={2}>
                Relationship: <span className="">{aofData?.nomineeRelation || '-'}</span>
              </td>
            </tr>
            <tr>
              <td colSpan={4}>
                Guardian Name (if Nominee is Minor):{" "}
                <span className="">{aofData?.nomineeGuardian || '-'}</span>
              </td>
            </tr>
            <tr>
              <td>
                City: <span className="">{aofData?.nominee_city || '-'}</span>
              </td>
              <td>
                Pincode: <span className="">{aofData?.nominee_pincode || '-'}</span>
              </td>
              <td colSpan={2}>
                State: <span className="">{aofData?.nominee_state || '-'}</span>
              </td>
            </tr>

            <tr>
              <td colSpan={4}>
                <span className="fw-bold text-decoration-underline">Declaration and Signature</span>
                <br />
                I/We confirm that details provided by me/us are true and correct. The ARN holder has disclosed to me/us all the
                commission (in the form of trail commission or any other mode), payable to him for the different competing
                schemes of various Mutual Funds from amongst which the scheme is being recommended to me/us.
              </td>
            </tr>
            <tr>
              <td colSpan={2}>
                Date:{" "}
                <span className="">
                  {aofData?.declarationDate
                    ? new Date(aofData.declarationDate).toLocaleDateString("en-GB")
                    : "-"}
                </span>
              </td>
              <td colSpan={2}>
                Place: <span className="">{aofData?.declarationPlace || '-'}</span>
              </td>
            </tr>
            {/* Signature Images Row */}
            <tr>
              <td style={{ textAlign: 'center' }}>
                {aofData?.signature_base64 ? (
                  <img
                    id="signature-image"
                    src={aofData.signature_base64}
                    alt="First Applicant Signature"
                    style={{ width: "200px", height: "60px" }}
                  />

                ) : (
                  <div style={{ width: "200px", height: "60px", border: "1px solid #ccc" }} />
                )}
              </td>
              <td style={{ textAlign: 'center' }}>
                {aofData?.secondApplicantSignature ? (
                  <img
                    src={aofData.secondApplicantSignature}
                    alt="Second Applicant Signature"
                    style={{ width: "200px", height: "60px" }}
                  />
                ) : (
                  <div style={{ width: "200px", height: "60px", border: "1px solid #ccc" }} />
                )}
              </td>
              <td style={{ textAlign: 'center' }} colSpan={2}>
                {aofData?.thirdApplicantSignature ? (
                  <img
                    src={aofData.thirdApplicantSignature}
                    alt="Third Applicant Signature"
                    style={{ width: "200px", height: "60px" }}
                  />
                ) : (
                  <div style={{ width: "200px", height: "60px", border: "1px solid #ccc" }} />
                )}
              </td>
            </tr>

            {/* Signature Labels Row */}
            <tr>
              <td className=" text-center">1st Applicant Signature</td>
              <td className=" text-center">2nd Applicant Signature</td>
              <td colSpan={2} className=" text-center">3rd Applicant Signature</td>
            </tr>
          </tbody>
        </Table>
      </form>
    </div></div>
  )
}

export default BseTable